<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">礼物投诉</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="content">
      <li v-for="(item,index) in data" :key="index" class="item ub ub-ac2 ub-pc">
        <div class="main ub">
          <div class="gift ub ub-ver ub-pc">
            <img :src="item.gift_url" />
            <span>{{item.gift_name}}</span>
          </div>

          <div class="send ub ub-ver ub-pc ub-f1">
            <span>赠送给</span>
            <img src="../../assets/img/右箭头.png" />
            <span>{{item.dtm}}</span>
          </div>

          <div class="receive ub ub-ac ub-pc ub-ver">
            <img :src="item.photo_url" />
            <span>{{item.nick}}</span>
          </div>
        </div>
        <div class="tousu ub ub-ac ub-pc" @click="goto_gift_tousu2(item.id,item.diff_hour,item.check_state)">
          <span class="txt" v-if="item.check_state==''">投诉</span>
          <span style="color:#ffa500;" v-if="item.check_state=='待审核'">待审核</span>
          <span style="color:#32cd32;" v-if="item.check_state=='通过'||item.check_state=='失败'">已处理</span>
        </div>

      </li>

      <div class="ub ub-pc ub-ac">
        <div v-if="data.length>0" class="ub ub-ac ub-pc btn"  @click="load_more()"><span>加载更多</span></div>
      </div>

      <div class="ub ub-pc ub-ver no-data" v-if="data.length <= 0">
        <img src="../../assets/img/暂无数据.png" class="no-data-img" />
        <div class="no-data-txt">你还没有送出过任何礼物</div>
        <div class="ub ub-ac ub-pc btn" @click="goto_qst()">礼物投诉规则 >></div>
      </div>
      <dlg ref="myForm_2"></dlg>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "@/components/Form";

export default {
  components: {
    dlg: Form
  },

  data() {
    return {
      data: [],
      index: 0,
      size: 10,
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_qst() {
      this.$router.push({ name: "qst" });
    },
    goto_gift_tousu2(id,diff_hour,check_state) {
      if(diff_hour>=24&&check_state==''){
        this.$toast.center("超过24小时的礼物不接受投诉");
        return false;
      }
      // 投诉需要关注公众号
      var skipWxCheck = this.$store.state.skipWxCheck;
        if(!skipWxCheck) {
          var wxInfo = this.$store.state.wxInfo;
          if(wxInfo == '')
          {
            this.show_sys_GuanzhuWx();
          }
        }
      this.$router.push({ name: "gift_touSu_dtl", params: { id: id } });
    },

    //关注公众号提示
    show_sys_GuanzhuWx() {
      var qrcode_url = require('../../assets/img/qrcode_xhc.jpg');
      var gzh_name = '小火柴';
      var code_link='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1NzM4MTAzOQ==#wechat_redirect';
      //加载dic信息
      var sysdic = this.$store.state.sysdic;
      if(sysdic){
        qrcode_url = sysdic.wx_gzh_qrcode;
        gzh_name = sysdic.wx_gzh_name;
      }
      var h = '<div style="line-height:1.6em;font-size:.85em;"><label style=" font-weight: bold;font-size:1.1em;">当前版本过低，<label style=" font-weight: bold;font-size:1.1em;color:red;">"礼物投诉"</label>功能无法使用</label>，请关注公众号【<a style="color: rgb(186, 97, 255)" href='+code_link+'>'+ gzh_name +'<a/>】，开启礼物投诉功能~<div>'
        + '<div class="ub ub-ac ub-pc dlg-img"><img src="' + qrcode_url + '"  style="margin: 1rem 0"/></div>'
        + '<div style="line-height:1.6em; text-align:center;">长按开启投诉功能<div>'
      this.$refs.myForm_2.show(h, {
        type: 'alert',
        confirmText: '长按上方二维码',
        titleText: '温馨提示',
        data: ''
      });
    },

    init() {
      this.load_more();
    },

    load_more() {
      this.$loading("加载...");

      var const_data = this.$store.state.const_data;
      var ary_gift = const_data.gift_1.concat(const_data.gift_2);

      //计算index
      var index = parseInt(this.data.length / this.size);
      if (index > this.index || (index == 0 && this.data.length == 0)) {
        this.index = index;
      } else {
        this.$toast.center("没有更多了~");
        this.$loading.close();
        return false;
      }

      //加载数据(按条数加载)
      var self = this;
      self.get({
        url:"/App/GetLeastGift/?uid=" +this.$store.state.uid +"&index=" +this.index +"&size=" +this.size,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.$loading.close();
          if (data) {
            for (var i = 0; i < data.length; i++) {
              data[i].photo_url =self.$store.state.url + "/photo/" + data[i].photo;
              var gift_item = tool.getGiftItemBy_name(ary_gift,data[i].gift_name);
              data[i].gift_url = gift_item.url;
            }
            self.data = self.data.concat(data);
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #EFEFEF;
}

.content {
  padding: 0 0.8rem;
}

.item {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  padding: 1rem 0.8rem;
  border-radius: 0.5rem;
  background-color: #FDFDFD;
  .main {
    align-items: center;
    .gift {
      img {
        width: 2.5rem;
      }
      span {
        margin-top: 0.5rem;
        font-size: 0.75rem;
        color: #333;
      }
    }
    .send {
      padding: 0 0.3rem;
      span {
        font-size: 0.65rem;
        color: #333;
      }
      img {
        height: 0.8rem;
      }
    }
    .send span:last-child {
      margin-top: 0.5rem;
    }
    .receive {
      margin-left: 0.5rem;
      img {
        margin-top: 0.5rem;
        width: 3rem;
        border-radius: 50%;
      }
      span {
        margin-top: 0.5rem;
        font-size: 0.75rem;
        color: #333;
      }
    }

  }
  .tousu {
    width: 4rem;
    height: 2rem;
    border-image: linear-gradient(180deg, rgba(138, 97, 255, 1), rgba(148, 231, 224, 1)) 1 1;
    color: #333;
    font-size: 0.75rem;
    border-radius: 0.5rem;
  }
}

.no-data {
  padding: 5rem 0;
  .no-data-img {
    width: 8rem;
    height: 8rem;
  }
  .no-data-txt {
    margin-top: 1rem;
    color: #afafaf;
    margin-left: 0.5rem;
  }
}
.btn{
    margin-top: 1rem;
    padding: 0.8rem 8rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    border-radius: 2rem;
    color: #fff;
    font-size: 0.9rem;
    font-weight: bold;
}

.container-dark {
  background-color: #2f2e33;
  .item {
    background-color: #2c2b30;
    .main {
      .gift {
        span {
          color: #fdfdfd;
        }
      }
      .send {
        span {
          color: #888;
        }
      }
      .receive {
        span {
          color: #fdfdfd;
        }
      }
    }
    .tousu {
        .txt {
          color: #888;
        }
      }
  }
}
</style>
